import { useContainerWidth } from '@fs/zion-ui'
import React, { Suspense, lazy } from 'react'
import { useGroupManagementGroupContext } from '../providers/GroupManagementGroupProvider'
import GroupDetailsPageSkeletons from './GroupDetailsPageSkeletons'

const FamilyGroupsContent = lazy(() => import('../components/details/family-groups/FamilyGroupsContent'))
const ResearcherTreesContent = lazy(() => import('../components/details/researcher-trees/ResearcherTreesContent'))

export default function LoadedGroupDetailsPage() {
  const { group } = useGroupManagementGroupContext()
  const atPageWidth = useContainerWidth()
  const isMobile = atPageWidth({ lg: false, default: true })
  const isResearcherGroup = group.types.includes('RESEARCHER_TREE')
  const collapsedLineCount = atPageWidth({
    default: { collapsedLineCount: 3 },
    xxl: { collapsedLineCount: 4 },
  })

  return (
    <>
      {!isResearcherGroup && (
        <Suspense fallback={<GroupDetailsPageSkeletons subPage="family" />}>
          <FamilyGroupsContent {...{ isMobile, collapsedLineCount }} />
        </Suspense>
      )}
      {isResearcherGroup && (
        <Suspense fallback={<GroupDetailsPageSkeletons subPage="research-tree" />}>
          <ResearcherTreesContent {...{ isMobile, collapsedLineCount }} />
        </Suspense>
      )}
    </>
  )
}
